export default {
  cloud: {
    url: 'https://trescolori.cloud',
    // url: 'https://trescolori-cloud.test',
  }
}